import { Fragment } from "react";
import {
  FaMagic,
  FaMicrophone,
  FaMicrophoneSlash,
  FaPaperPlane,
  FaPowerOff,
  FaVideo,
  FaVideoSlash,
} from "react-icons/fa";
import { MdOutlineScreenShare, MdOutlineStopScreenShare } from "react-icons/md";
import styled from "styled-components";
import { useContext } from "use-context-selector";
import { SendLinkModalContext } from "../../../context/SendLinkModalContext";
import { useLocalParticipant } from "../../../hooks/useLocalParticipant";
import { useRoom } from "../../../hooks/useRoom";
import { useVideoChat } from "../../../hooks/useVideoChat";
import ActionRowButton from "../../Buttons/ActionRowButton";

const Wrapper = styled("div")<{ spacing: number }>`
  display: flex;
  align-items: center;
  gap: ${(props) => props.spacing}px;
  position: absolute;
  justify-content: center;
  width: 100%;
  @container (max-width: 500px) {
    position: relative;
  }
`;

const LeaveIcon = styled(FaPowerOff)`
  fill: rgb(226, 38, 38) !important;
`;

interface IActionButtons {
  buttonsSpacing: number;
}

const ActionButtons = ({ buttonsSpacing }: IActionButtons) => {
  const { permission } = useVideoChat();
  const { handleLeaveRoom, room } = useRoom();
  const { handleOpenSendLinkModal } = useContext(SendLinkModalContext);
  const {
    sharingScreen,
    handleShareScreen,
    audioOff,
    handleAudio,
    videoOff,
    handleVideo,
    setShowEffectsModal,
  } = useLocalParticipant();
    
  const screenSharer = Array.from(room?.participants.values() || []).find((participant) =>
    Array.from(participant.videoTracks.values()).some((pub) => pub.track?.name === "screen")
  );
  
  const screenSharerName = screenSharer?.identity?.split("-").slice(1, -1).join("-") || "Outro participante";
  const isLocalSharing = sharingScreen;
  const isBlocked = !isLocalSharing && screenSharer;
    

  return (
    <Wrapper spacing={buttonsSpacing}>
      <Fragment>
        {permission !== "patient" && (
          <ActionRowButton
            tooltip={"Reenviar SMS e e-mail com o link"}
            handleClick={handleOpenSendLinkModal}
            Icon={FaPaperPlane}
            iconSize={23}
          />
        )}
        <ActionRowButton
          tooltip={
            isLocalSharing
              ? "Parar compartilhamento"
              : isBlocked
              ? `${screenSharerName} já está compartilhando a tela.`
              : "Compartilhar tela"
          }
          handleClick={handleShareScreen}
          Icon={sharingScreen ? MdOutlineStopScreenShare : MdOutlineScreenShare}
          disabled={Boolean(isBlocked)}
        />
      </Fragment>

      <ActionRowButton
        tooltip={audioOff ? "Habilitar áudio" : "Desabilitar áudio"}
        handleClick={handleAudio}
        Icon={audioOff ? FaMicrophoneSlash : FaMicrophone}
        iconSize={audioOff ? undefined : 22}
      />

      <ActionRowButton
        tooltip={videoOff ? "Habilitar câmera" : "Desabilitar câmera"}
        handleClick={handleVideo}
        Icon={videoOff ? FaVideoSlash : FaVideo}
      />

      <ActionRowButton
        tooltip={"Mudar plano de fundo da câmera"}
        Icon={FaMagic}
        handleClick={() => setShowEffectsModal(true)}
        iconSize={22}
      />

      <ActionRowButton tooltip={"Sair da sala"} handleClick={handleLeaveRoom} Icon={LeaveIcon} />
    </Wrapper>
  );
};

export default ActionButtons;
